import { AxiosInstance } from "axios";
import { PinResponse } from "../types/Email";

export const pinService = {  
  createPin: async (api: AxiosInstance, email: string): Promise<PinResponse> => {
    try {
      const response = await api.post(`/auth/pin/create?email=${encodeURIComponent(email)}`);
      return response.data as PinResponse;
    } catch (error: any) {
      console.error("Erreur lors de la création du PIN :", error);
      return {
        success: false,
        message: error.response?.data || "Erreur lors de la création du PIN"
      };
    }
  },
  verifyPin: async (api: AxiosInstance, email: string, pin: string): Promise<boolean> => {
    try {
      const response = await api.get(`/auth/pin/verify`, {
        params: { email, pin }
      });
      return response.data as boolean;
    } catch (error: any) {
      console.error("Erreur lors de la vérification du PIN :", error);
      throw error.response?.data || error;
    }
  },
};
